export default function () {
    const menuButton = document.querySelector('.header__home-logo');
    const menu = document.querySelector('.header__home-nav');
    const body = document.querySelector('body');

    function toggleMenu() {
        menu.classList.toggle('open');
        body.classList.toggle('menu-active');
    }

    function handleMenuClick(e) {
        e.preventDefault();
        if (e.target === menuButton) {
            toggleMenu();
        }
    }

    function handleMenuMouseOver() {
        if (window.innerWidth >= 992) {
            toggleMenu();
        }
    }

    function handleMenuMouseOut(e) {
        if (window.innerWidth >= 992) {
            //add if to FIX BOTTOM MENU APPEAR EFFECT
            if (!menu.contains(e.relatedTarget)) {
                toggleMenu();
            }
        }
    }

    function handleDocumentClick(e) {
        if (window.innerWidth <= 992 && !menu.contains(e.target) && e.target !== menuButton) {

            menu.classList.remove('open');
            body.classList.remove('menu-active');
        }
    }

    function handleResize() {
        if (window.innerWidth >= 992) {
            menu.classList.remove('open');
            body.classList.remove('menu-active');
        }
    }

    function handleSectionScroll() {
        const urlParams = new URLSearchParams(window.location.search);
        const sectionToScroll = urlParams.get('section');

        if (sectionToScroll) {
            const targetElement = document.getElementById(sectionToScroll);
            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop,
                    behavior: 'smooth'
                });
            }
        }
    }

    menuButton.addEventListener('click', handleMenuClick);
    menuButton.addEventListener('mouseover', handleMenuMouseOver);
    menu.addEventListener('mouseout', handleMenuMouseOut);
    window.addEventListener('resize', handleResize);
    window.addEventListener('resize', handleSectionScroll);

    document.addEventListener('click', handleDocumentClick);

    handleResize();

    function addMarginOnResize() {

        let headerHeight = document.querySelector('.header').offsetHeight;
        let projectsElement = document.querySelector('.projects');

        function updateMargin() {
            let windowWidth = window.innerWidth;

            if (windowWidth <= 992) {
                projectsElement.style.paddingTop = (headerHeight+48) + 'px';
            } else {
                projectsElement.style.paddingTop = (headerHeight) + 'px';
            }
        }

        updateMargin();

        window.addEventListener('resize', updateMargin);
    }

    window.addEventListener('load', addMarginOnResize);
    window.addEventListener('resize', addMarginOnResize);

}
